import { formatNumber } from 'components/QuickenControls/AmountField';

export type ChartDataType = {
  from: number;
  to: number;
  value: number;
  label: string;
  fill: string;
  graphValue: string;
};

export const generateChartData = (
  totalSpendings: number, 
  annualBudget: number, 
  totalSavings: number, 
  currency: string, 
  theme: Record<string, any>, 
  amountFormat: string,
): ChartDataType[] => {

  const chartData:ChartDataType[] = [];
  let annualBudgetForCalculation = annualBudget;
  if (totalSpendings < annualBudget) {
    chartData.push({
      from: chartData[chartData.length - 1]?.to || 0,
      to: totalSpendings,
      value: totalSpendings,
      label: '',
      fill: theme?.palette.success.main,
      graphValue: Number(formatNumber(totalSpendings, '', amountFormat)) === 0 ? '' : formatNumber(totalSpendings, currency, amountFormat),
    }, {
      from: totalSpendings,
      to: annualBudget,
      value: annualBudget,
      label: '',
      fill: theme?.palette.background.positive,
      graphValue: '',
    });
  } else {
    annualBudgetForCalculation = totalSpendings - annualBudget;
    chartData.push({
      from: chartData[chartData.length - 1]?.to || 0,
      to: annualBudget,
      value: annualBudget,
      label: '',
      fill: theme?.palette.success.main,
      graphValue: Number(formatNumber(annualBudget, '', amountFormat)) === 0 ? '' : formatNumber(annualBudget, currency, amountFormat),
    }, {
      from: annualBudget,
      to: annualBudget + annualBudgetForCalculation,
      value: totalSpendings,
      label: '',
      fill: theme?.palette.status.dangerMain,
      graphValue: '',
    });
  }

  chartData.push({
    from: chartData[chartData.length - 1]?.to || 0,
    to: (chartData[chartData.length - 1]?.to || 0) + totalSavings,
    value: totalSavings,
    label: '',
    fill: theme?.palette.background.elevated,
    graphValue: '',
  });

  return chartData;
};
